import { useRoute } from '@nuxtjs/composition-api';

const DEBUG_PREFIX = 'o_';
const GROUP_BG_COLOR = '#aaa';
const DEBUG_BG_COLOR = '#8A0707';

export const useDebug = (groupName) => {
  const route = useRoute();
  const isDebugMode = route.value.query?.[`${DEBUG_PREFIX}debug`] !== undefined;
  const queries = route.value.query;
  const queryKeys = Object.keys(queries);
  const debugQueries = queryKeys.reduce((result, currKey) => {
    if (currKey.startsWith(DEBUG_PREFIX) && isDebugMode) {
      const slicedKey = currKey.slice(DEBUG_PREFIX.length);
      result[slicedKey] = queries[currKey] === null ? 'true' : queries[currKey];
    }
    return result;
  }, {});
  const logFactory = (args) => {
    const messages = Array.from(args);
    const label = (bgColor) => {
      return `display: inline-block; border-radius: 3px; color: #fff; padding: 1px 4px; background: ${bgColor}`;
    };
    if (groupName) {
      messages.unshift(label(GROUP_BG_COLOR));
    }
    messages.unshift(label(DEBUG_BG_COLOR));
    messages.unshift('%cOnedio' + (groupName ? `%c${groupName}` : ''));
    return messages;
  };
  function oLog() {
    if (isDebugMode) {
      console.log.apply(console, logFactory(arguments));
    }
  }
  return { isDebugMode, oLog, debugQueries };
};
